import { useEffect } from "react";
import { tipoSolicitudCambioCic } from "../../../constantes/tipoSolicitudCambioCic";
import CorreosSolicitud from "./Secciones/CorreosSolicitud";
import OperacionesCambioDeudor from "../CambioDeudor/OperacionesCambioDeudor";
import DocumentosSolicitudCambioCic from "./Secciones/DocumentosSolicitudCambioCic";
import HistoricoEstadosSolicitud from "./Secciones/HistoricoEstadosSolicitud";
import OperacionesCambioCuotasAtrasadas from "../CuotasAtrasadas/OperacionesCambioCuotasAtrasadas";
import OperacionesModificarMotivoLiquidacion from "../MotivoLiquidacion/OperacionesModificarMotivoLiquidacion";
import OperacionesIncluirOperacionNoReportada from "../IncluirOperacionNoReportada/OperacionesIncluirOperacionNoReportada";
import OperacionesCambioCodeudor from "../CambioCodeudor/OperacionesCambioCodeudor";
import OperacionesCambioCuentasPorCobrar from "../CuentasPorCobrar/OperacionesCambioCuentasPorCobrar";
import OperacionesDelDeudor from "../EliminarOperacion/OperacionesDelDeudor";
import IdentificacionesAsociadas from "../../Comunes/IdentificacionesAsociadas/IdentificacionesAsociadas";
import { _VerificarArray } from "../../../Utils/Funciones";

function DetalleSolicitudCambioCic({ detalleSolicitud }) {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  });

  return (
    <>
      <div className="card mb-4 shadow">
        <div className="card-header">
          <h6 className="m-0 font-weight-bold text-primary">
            Detalle de la Solicitud
          </h6>
        </div>
        <div className="card-body">
          <h4 className="card-title text-center text-primary">
            {detalleSolicitud.tipoSolicitudCambio.descripcion}
          </h4>
          <h5 className="card-subtitle text-center mb-2">
            Consecutivo: {detalleSolicitud.consecutivo}
          </h5>
          <h5 className="card-subtitle text-center mb-2">
            Entidad: {detalleSolicitud.entidad.alias}
          </h5>
          <h5 className="card-subtitle text-center mb-4">
            <span className="badge badge-info">
              {detalleSolicitud.estado.descripcion}
            </span>
          </h5>

          {/* Datos del Deudor y Nuevo Deudor */}
          <table className="table table-sm mb-4">
            <thead className="thead-light">
              <tr>
                <th></th>
                <th>Tipo Persona</th>
                <th>Identificación</th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong>Deudor</strong>
                </td>
                <td>
                  {
                    detalleSolicitud.identificacionDeudor.tipoPersona
                      .descripcionLarga
                  }
                </td>
                <td>{detalleSolicitud.identificacionDeudor.codigo}</td>
                <td>{detalleSolicitud.nombreDeudor}</td>
              </tr>
              {detalleSolicitud.tipoSolicitudCambio.codigo ===
              tipoSolicitudCambioCic.TrasladarInformacionCrediticiaDeUnDeudorAOtro ? (
                <tr>
                  <td>
                    <strong>Nuevo Deudor</strong>
                  </td>
                  <td>
                    {
                      detalleSolicitud.identificacionNuevoDeudor.tipoPersona
                        .descripcionLarga
                    }
                  </td>
                  <td>{detalleSolicitud.identificacionNuevoDeudor.codigo}</td>
                  <td>{detalleSolicitud.nombreNuevoDeudor}</td>
                </tr>
              ) : null}
            </tbody>
          </table>

          <div id="identificacionesAsociadas">
              {  detalleSolicitud.identificacionesAsociadas != null && _VerificarArray(detalleSolicitud.identificacionesAsociadas)  != null ? (
                <IdentificacionesAsociadas
                  Identificaciones={detalleSolicitud.identificacionesAsociadas}
                  Titulo={ "Identificaciones Asociadas del Deudor" }
                />
              ) : null}
            </div>
            
          {/* Lista de Operaciones */}
          {detalleSolicitud.tipoSolicitudCambio.codigo ===
          tipoSolicitudCambioCic.TrasladarInformacionCrediticiaDeUnDeudorAOtro ? (
            <OperacionesCambioDeudor
              operaciones={detalleSolicitud.listaOperaciones.listadoOperaciones}
            />
          ) : null}

          {detalleSolicitud.tipoSolicitudCambio.codigo ===
          tipoSolicitudCambioCic.ModificarOEliminarCuotasAtrasadas ? (
            <OperacionesCambioCuotasAtrasadas
              operaciones={
                detalleSolicitud.listaOperaciones.listaCuotasAtrasadas
              }
              soloLectura={true}
            />
          ) : null}

          {detalleSolicitud.tipoSolicitudCambio.codigo ===
          tipoSolicitudCambioCic.ModificarMotivoDeLiquidacion ? (
            <OperacionesModificarMotivoLiquidacion
              operaciones={
                detalleSolicitud.listaOperaciones
                  .listadoModificarMotivoLiquidacion
              }
              soloLectura={true}
            />
          ) : null}

          {detalleSolicitud.tipoSolicitudCambio.codigo ===
          tipoSolicitudCambioCic.IncluirMotivoDeLiquidacion ? (
            <OperacionesIncluirOperacionNoReportada
              operaciones={
                detalleSolicitud.listaOperaciones
                  .listadoIncluirMotivoLiquidacion
              }
              soloLectura={true}
            />
          ) : null}

          {detalleSolicitud.tipoSolicitudCambio.codigo ===
          tipoSolicitudCambioCic.ExcluirOSustituirCodeudor ? (
            <OperacionesCambioCodeudor
              operaciones={
                detalleSolicitud.listaOperaciones
                  .listadoExcluirSustituirCodeudor
              }
              soloLectura={true}
            />
          ) : null}

          {detalleSolicitud.tipoSolicitudCambio.codigo ===
          tipoSolicitudCambioCic.ModificarOEliminarCuentasPorCobrarAsociadas ? (
            <OperacionesCambioCuentasPorCobrar
              operaciones={
                detalleSolicitud.listaOperaciones.listaCuentasPorCobrar
              }
              soloLectura={true}
            />
          ) : null}

      {detalleSolicitud.tipoSolicitudCambio.codigo ===
          tipoSolicitudCambioCic.EliminarOperacion ? (
            <OperacionesDelDeudor
              operaciones={
                detalleSolicitud.listaOperaciones
                  .listadoOperaciones
              }
              soloLectura={true}
            />
          ) : null}

          <div className="card mb-4 shadow">
            <div className="card-header">
              <h6 className="m-0 font-weight-bold text-primary">
                Justificación y Acciones Correctivas
              </h6>
            </div>
            <div className="card-body">
              <h5 className="card-title">Justificación</h5>
              <p>{detalleSolicitud.justificacion}</p>

              <h5 className="card-title mt-4">Acciones Correctivas</h5>
              <p>{detalleSolicitud.accionesCorrectivas}</p>
            </div>
          </div>

          {/* Archivos */}
          <DocumentosSolicitudCambioCic
            documentos={detalleSolicitud.listaArchivos}
            permiteDescargar="true"
          />

          {/* Listado de Correos */}
          <CorreosSolicitud listaCorreos={detalleSolicitud.listaCorreos} />

          {/* Histórico de Estados */}
          <HistoricoEstadosSolicitud
            historicoEstados={detalleSolicitud.historicoEstados}
          />
        </div>
      </div>
    </>
  );
}

export default DetalleSolicitudCambioCic;
